import { render, staticRenderFns } from "./mdf-submit-pop-widget.vue?vue&type=template&id=5ba2ae3d&"
import script from "./mdf-submit-pop-widget.vue?vue&type=script&lang=js&"
export * from "./mdf-submit-pop-widget.vue?vue&type=script&lang=js&"
import style0 from "./mdf-submit-pop-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports